import React from "react";
import cls from './style.module.scss';
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../../../../components/icon/iconfont";

const ReturnOrderLayout = props =>{
    useStyles(cls);

    return <div className={cls.ReturnOrderLayout}>
        <div className={cls.Hd}>
            {props.topSlot}

            <Iconfont className={cls.CloseIcon} onClick={props?.onClose}>&#xe69a;</Iconfont>
        </div>

        <div className={cls.Bd}>
            {props.children}
        </div>

        <div className={cls.Fd}>
            {props.bottomSlot}
        </div>
    </div>
}

export default ReturnOrderLayout;